import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { ContextCheckInIntroStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';
import { getZodiac, getZodiacCharacterTrait, getZodiacLuckyDays } from '@packages/shared/core/user/store/selectors';

type ContextCheckInIntroQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const ContextCheckInIntroQuizStep = ({ id, renderQuizScreen }: ContextCheckInIntroQuizStepProps) => {
  const logger = useLogger();

  const { back, next, stepData, userPreferences } = useQuizStep(id);

  const zodiac = useSelector(getZodiac);
  const characterTrait = useSelector(getZodiacCharacterTrait);
  const luckyDays = useSelector(getZodiacLuckyDays);

  if (!stepData) {
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const goBack = async () => back();

  const onContinue = async () => {
    await next();
  };

  return (
    <>
      {renderQuizScreen({
        onContinue,
        onBack: goBack,
        zodiac,
        characterTrait,
        luckyDays,
        userPreferences,
        ...(stepData as ContextCheckInIntroStepData),
      })}
    </>
  );
};

export default ContextCheckInIntroQuizStep;
